import { useQuery } from '@tanstack/react-query';

import { getMarkets } from '@arrived/api_v2';
import { Market } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { marketsKey } from './markets.keys';

// TODO: This returns _all_ markets, including ones without any Offerings, there should maybe be an endpoint or a query
//  param that will allow us to only get markets that are attached to current offerings.
export function useGetMarketsQuery(options?: UseQueryOptions<Market[]>) {
  return useQuery(marketsKey, () => getMarkets(), { ...options, staleTime: options?.staleTime ?? MAX_STALE_TIME });
}
